import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/AuthContext';
import { useGroup } from '../context/GroupContext';
import { supabase } from '../lib/supabase';
import { attachNativePush, isAndroidPush } from '../lib/nativePush';
import { useToast } from './ToastProvider';

export default function NativePushBridge() {
  const { user } = useUser();
  const { activateGroup } = useGroup();
  const navigate = useNavigate();
  const toast = useToast();
  const refs = useRef();
  refs.current = { activateGroup, toast };
  useEffect(() => {
    if (!isAndroidPush() || !user?.id) return undefined;
    let disposed = false;
    let detach;
    const open = async (path, destination) => {
      try {
        if (disposed) return;
        if (destination.groupId) {
          const { data, error } = await supabase.from('group_users').select('group_id').eq('group_id', destination.groupId).eq('user_id', user.id).maybeSingle();
          if (error || !data) throw new Error('Je hebt geen toegang meer tot de groep van deze melding.');
          if (disposed) return;
          await refs.current.activateGroup(destination.groupId);
        }
        if (!disposed) navigate(path);
      } catch (error) { refs.current.toast?.show(error.message || 'De melding kon niet worden geopend.', { type: 'error' }); }
    };
    attachNativePush(open).then((cleanup) => {
      if (disposed) cleanup();
      else detach = cleanup;
    }).catch(() => {});
    return () => { disposed = true; detach?.(); };
  }, [user?.id, navigate]);
  return null;
}
